module.exports = __webpack_public_path__ + "img/SportsCritical.86996176.svg";